export type WorkOrderRouteTab =
  | 'detail'
  | 'samples'
  | 'sampling_plan'
  | 'sampling_plan_air'
  | 'sampling_plan_non_air'
  | 'survey_team';

export function parseWorkOrderRouteHash(hash: string): {
  tab: WorkOrderRouteTab;
  sampleId: string | null;
} {
  const trimmed = (hash || '').replace(/^#/, '').trim();
  if (!trimmed) {
    return { tab: 'detail', sampleId: null };
  }
  const [tabPart, queryPart] = trimmed.split('?');
  const tabNorm = (tabPart || '').toLowerCase();
  let tab: WorkOrderRouteTab = 'detail';
  if (tabNorm === 'samples') tab = 'samples';
  else if (tabNorm === 'sampling_plan_air' || tabNorm === 'sampling-plan-air') tab = 'sampling_plan_air';
  else if (
    tabNorm === 'sampling_plan_non_air' ||
    tabNorm === 'sampling-plan-non-air' ||
    tabNorm === 'sampling_plan_udara' ||
    tabNorm === 'sampling-plan-udara'
  ) {
    tab = 'sampling_plan_non_air';
  } else if (tabNorm === 'sampling_plan' || tabNorm === 'sampling-plan') tab = 'sampling_plan';
  else if (tabNorm === 'survey_team' || tabNorm === 'survey-team') tab = 'survey_team';
  else if (tabNorm === 'pic') tab = 'detail';
  let sampleId: string | null = null;
  if (
    (tab === 'samples' ||
      tab === 'sampling_plan' ||
      tab === 'sampling_plan_air' ||
      tab === 'sampling_plan_non_air') &&
    queryPart
  ) {
    const params = new URLSearchParams(queryPart);
    const raw = params.get('sampleID')?.trim();
    sampleId = raw || null;
  }
  return { tab, sampleId };
}

export function buildWorkOrderRouteHash(tab: WorkOrderRouteTab, sampleId?: string | null): string {
  if (tab === 'detail') {
    return '#detail';
  }
  if (tab === 'survey_team') {
    return '#survey_team';
  }
  if (tab === 'sampling_plan_air') {
    return sampleId?.trim()
      ? `#sampling_plan_air?sampleID=${encodeURIComponent(sampleId.trim())}`
      : '#sampling_plan_air';
  }
  if (tab === 'sampling_plan_non_air') {
    return sampleId?.trim()
      ? `#sampling_plan_non_air?sampleID=${encodeURIComponent(sampleId.trim())}`
      : '#sampling_plan_non_air';
  }
  if (sampleId?.trim()) {
    return `${tab === 'sampling_plan' ? '#sampling_plan' : '#samples'}?sampleID=${encodeURIComponent(sampleId.trim())}`;
  }
  return tab === 'sampling_plan' ? '#sampling_plan' : '#samples';
}

/**
 * Normalize route tab for sampling-plan-* panels.
 * Legacy `#samples` maps to `#sampling_plan`. Air/non-air tabs stay as-is when available.
 */
export function resolveSamplingPlanRouteTab(
  tab: WorkOrderRouteTab,
  opts: { hasAir: boolean; hasNonAir: boolean },
): 'sampling_plan' | 'sampling_plan_air' | 'sampling_plan_non_air' | null {
  const { hasAir, hasNonAir } = opts;
  if (tab === 'sampling_plan' || tab === 'samples') {
    return 'sampling_plan';
  }
  if (tab === 'sampling_plan_air') {
    if (hasAir) return 'sampling_plan_air';
    return 'sampling_plan';
  }
  if (tab === 'sampling_plan_non_air') {
    if (hasNonAir) return 'sampling_plan_non_air';
    return 'sampling_plan';
  }
  return null;
}
